import React from 'react'
import { func, string } from 'prop-types'
import { css } from '@emotion/react'
import {
  Button,
  Modal,
  ModalPortal,
} from '@livechat/design-system-react-components'

import AddHdProduct from '@/assets/images/cart/add-hd-product.inline.svg'
import AddLcProduct from '@/assets/images/cart/add-lc-product.inline.svg'
import AvatarIcon from '@/assets/images/cart/avatar.png'
import { PRODUCT, navigateToIFrame, activeProduct } from '@/utils'
import { getDesignationLabel } from '@/utils/products'

const modalCss = css`
  max-width: 700px !important;
`

const headerCss = css`
  display: flex;
  align-items: center;
  gap: 8px;

  > p {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    margin: 0;
  }
`

const footerCss = css`
  display: flex;
  gap: 8px;
`

const wrapperCss = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > div {
    max-width: 50%;
  }

  > svg {
    width: 300px;
    height: 300px;
  }

  h3 {
    font-size: 25px;
    font-weight: 700;
    line-height: 30px;
  }

  p {
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
  }
`

const ActivateSubscriptionModal = ({ onCloseModal, onClick, product }) => {
  if (!product) {
    return null
  }

  const designation = getDesignationLabel(product)
  const currentProduct = getDesignationLabel(activeProduct)

  const handleLearnMoreClick = (e) => {
    if (product === PRODUCT.LiveChat) {
      window.open('https://www.livechat.com/', '_blank')
    } else {
      navigateToIFrame(e, '/marketplace/apps/helpdesk/', product)
    }
  }

  return (
    <ModalPortal>
      <Modal
        css={modalCss}
        onClose={onCloseModal}
        footer={
          <div css={footerCss}>
            <Button onClick={handleLearnMoreClick} kind="secondary">
              Learn more about {designation}
            </Button>
            <Button onClick={onClick} kind="primary">
              Activate & set the subscription
            </Button>
          </div>
        }
      >
        <div css={headerCss}>
          <img src={AvatarIcon} alt="Support Staff Avatar" />
          <p>Hi, do you want to activate and try {designation}?</p>
        </div>
        <div css={wrapperCss}>
          <div>
            <h3>
              Connect {designation} with {currentProduct} in just a few clicks
            </h3>
            <p>Turn "real-time" support into "in-your-time" support</p>
          </div>

          {product === PRODUCT.LiveChat && <AddLcProduct />}
          {product === PRODUCT.HelpDesk && <AddHdProduct />}
        </div>
      </Modal>
    </ModalPortal>
  )
}

ActivateSubscriptionModal.propTypes = {
  onCloseModal: func,
  onClick: func,
  product: string,
}

export default ActivateSubscriptionModal
